import React, { useState, useCallback, useEffect } from 'react';
import {
    Grid,
    Box,
    Typography,
    Divider,
    Avatar,
    Checkbox,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useDropzone } from 'react-dropzone';
import { CloseIcon, NoImage, PlusIcon, Upload, Minus } from '../../../assets';
import { CustomReactSelect, CustomButton, CustomEditor, ConfirmationModal } from '../../shared';
import { useDispatch, useSelector } from 'react-redux';
import { editCustomerDetails, getEditCustomerSettings } from '../../../redux/thunks/companyThunks';
import { content_type, subject_line, topic } from './constants';
import { actions } from '../../../redux/reducers/companyReducer';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';


const useStyles = makeStyles((theme) => ({
    root: {
        '&$checked': {
            color: '#8C3F7D',
        },
    },
    checked: {},
}));

const schema = yup.object().shape({
    channel: yup.string().required('Channel is required'),
    topic: yup.string().required('Topic is required'),
    vendor: yup.string().required('Vendor is required'),
    content_type: yup.string(),
    subject_line: yup.string(),
    image:yup.mixed(),
    listImage_url:yup.mixed(),
    isChecked: yup.boolean().default(false),
  });

const UploadAsset = (props) => {
    const { handleClose, type } = props;
    const classes = useStyles();
    const [finalData, setFinalData] = useState({});
    const [open, setOpen] = useState(false);
    const { customersSetting,company } = useSelector((state) => state.company)
    const { editCustomer, editCustomerData, channel, vendor } =customersSetting
    const dispatch = useDispatch()
    const { register, handleSubmit, setValue,getValues, formState: { errors }, watch} = useForm({
        resolver: yupResolver(schema),
      });
    useEffect(() => {
        if(editCustomer?.length>0){
            dispatch(getEditCustomerSettings({customerId: editCustomer[0]?.id}))
        }
        if(editCustomerData.length>0){
            setValue('channel', editCustomerData?.channel)
            setValue('topic', editCustomerData?.topic)
            setValue('vendor', editCustomerData?.vendor)
            setValue('listImage_url', editCustomerData?.image)
        }
    },[editCustomer])

    useEffect(() => {
        if(Object?.keys(editCustomerData).length>1){
            setValue('channel', editCustomerData?.channel)
            setValue('topic', editCustomerData?.topic)
            setValue('vendor', editCustomerData?.vendor)
        }
    },[editCustomerData])

    const onclose = () =>{
        setOpen(!open)
    }

    const handleContentChange = (value) => {
        dispatch(actions.getDataForEdit({ payload: { field: 'content', value: value}}));
    };

   
    const handleChannel = (option) => {
        dispatch(actions.getDataForEdit({ type: 'UPDATE_FIELD', payload: { field: 'channel', value: option.value}}))
    };
    const handleSelect = (e,option,id) => {
        switch(e){
            case "channel" : 
            setValue('channel', option.value)
            dispatch(actions.getDataForEdit({ payload: { field: 'channel', value: option.value}}));
            break;
            case "vendor" : 
            setValue('vendor', option.value)
            dispatch(actions.getDataForEdit({ payload: { field: 'vendor', value: option.value}}));
            break;
            case "topic" : 
            setValue('topic', option.value)
            dispatch(actions.getDataForEdit({ payload: { field: 'topic', value: option.value}}));
            break;
            case "content_type" :
            dispatch(actions.getDataForEdit({ payload: { field: 'content_type', value: {id: id, content_type: option.value}}}));
            break;
        }
        
    };

    const onDrop = useCallback(
        (acceptedFiles) => {
            const file = acceptedFiles[0];
            const blobUrl = URL.createObjectURL(file);
            setValue('listImage_url', blobUrl);
            setValue('image', file); 
        },
        [setValue]
    );

    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        accept: {
            'image/png': ['.png'],
            'image/jpeg': ['.jpg', '.jpeg'],
            'image/svg+xml': ['.svg'],
        },
    });

    const onFileSelect = (file) => {
        const files = file;
        const blobUrl = URL.createObjectURL(file);
        setValue('listImage_url', URL.createObjectURL(blobUrl));
        setValue('image', files); 
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        onFileSelect(file);
    };

    const handleSubjectLineChange = (e, id) => {
        dispatch(actions.getDataForEdit({ payload: { field: 'subject_line', value:{id: id, subject_line: e.target.value} }}));
    };

    const onSubmit = (data) => {
        if (getValues('isChecked') === true) {
            dispatch(actions.triggerIsChecked());
            setOpen(true);
            const formData = new FormData();
            formData.append('content', editCustomerData?.content || '');
            formData.append('image', data?.image || editCustomerData?.image);
            formData.append('id', editCustomer[0]?.id || '');
            formData.append('company_id', company.id);
            formData.append('channel', editCustomerData?.channel || '');
            formData.append('topic', editCustomerData?.topic || '');
            formData.append('vendor', editCustomerData?.vendor || '');
            formData.append('subject_line', '');
            const contentTypes =
            editCustomerData?.content_type?.length === 1 &&
                !editCustomerData?.content_type[0]?.content_type &&
                !editCustomerData?.content_type[0]?.subject_line
                ? null
                : editCustomerData?.content_type || null
            const contentTypesJSON = JSON.stringify(contentTypes);
            formData.append('content_type', contentTypesJSON);
    
            setFinalData(formData);
        } else {
            setOpen(false);
            alert('You Need to Acknowledge that this campaign has met the required reviewer approvals.');
        }
    };
    const handleSave = () => {
        handleSubmit(onSubmit);
    };

    const finalSubmit = () => {
        dispatch(editCustomerDetails({data: finalData })).then(result=>{
            if(result?.payload?.status_code){
                setOpen(false);
                handleClose()
            }
        });
        
    }
    
    return (
        <form onSubmit={handleSubmit(onSubmit)}>
        <Grid
            container
            className='modal_main'>
            <Grid item xs={12}>
                <Box className="padding-24px">
                    {/* Upload New Asset Here */}
                    <Box className="flex-row-space-between pb-24px">
                        <Typography className="text-lg-medium gray-900">
                            {type}
                        </Typography>
                        <Box className="icon" onClick={handleClose}>
                            <CloseIcon color="#98A2B3" width='12' height='12' />
                        </Box>
                    </Box>

                    {/* Select Channel and Topic */}
                        <Box className="pb-24px">
                            <Grid container spacing={'24px'} className='flex-row'>
                                <Grid item xs={6}>
                                    <CustomReactSelect
                                        label='Select Channel'
                                        options={channel}
                                        handleFilter={(option) => handleSelect("channel", option)}
                                        placeholder="Select Channel"
                                        selectedOption={editCustomerData ? { "label": editCustomerData?.channel, "value": editCustomerData?.channel } : {}}
                                        {...register('channel')}
                                    />
                                    {errors.channel && !watch('channel') && (
                                        <Typography className="text-xs-regular error-500">{errors.vendor.message}</Typography>
                                    )}
                                </Grid>
                                <Grid item xs={6}>
                                    <CustomReactSelect
                                        label='Select Topic'
                                        options={topic}
                                        handleFilter={(option) => handleSelect("topic", option)}
                                        placeholder="Select Topic"
                                        selectedOption={editCustomerData ? { "label": editCustomerData?.topic, "value": editCustomerData?.topic } : {}}
                                        {...register('topic')}
                                    />
                                    {errors.channel && !watch('topic') && (
                                        <Typography className="text-xs-regular error-500">{errors.topic.message}</Typography>
                                    )}
                                </Grid>
                            </Grid>
                        </Box>

                    {/* Select Vendor and Content Type */}
                    <Box className="pb-24px">
                        <Grid container spacing={'24px'} className='flex-row'>
                            <Grid item xs={6}>
                                <CustomReactSelect
                                    label='Select Vendor'
                                    options={vendor}
                                    handleFilter={(option) => handleSelect("vendor",option)}
                                    placeholder="Select Vendor"
                                    selectedOption={{"label":editCustomerData?.vendor,"value":editCustomerData?.vendor}}
                                    {...register('vendor')}
                                />
                                {errors.channel && !watch('vendor') && (
                                        <Typography className="text-xs-regular error-500">{errors.channel.message}</Typography>
                                    )}
                            </Grid>
                        </Grid>
                    </Box>

                    {/* Type Subject Line and Select Subject Line */}
                    <Box>
                        {editCustomerData?.content_type?.map(line => (<Grid container spacing={'24px'} className="flex-row-center-end" key={line.id}>
                            <Grid item xs={5}>
                                <Box>
                                    <Typography className='text-sm-medium gray-700'>
                                        Type Subject Line Here
                                    </Typography>
                                    <input
                                        type="text"
                                        placeholder='Type Subject Line'
                                        className='custom-text-field'
                                        value={line.subject_line}
                                        onChange={(e) => handleSubjectLineChange(e, line.id)}
                                    />
                                </Box>

                            </Grid>
                            <Grid item xs={5}>
                            <CustomReactSelect
                                    label='Content Type'
                                    options={content_type}
                                    handleFilter={(option) => handleSelect("content_type",option,line.id)}
                                    selectedOption={{"label":line?.content_type,"value":line?.content_type}}
                                    placeholder="Select Content Type"
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <Box className="flex-row gap-8">
                                    <Box className="border-1-gray-300 br-8px padding-6px icon" onClick={() => dispatch(actions.removeContentType({id:line.id}))}>
                                        <Minus color='#344054' />
                                    </Box>
                                    <Box className="border-1-gray-300 br-8px padding-6px icon" onClick={() => dispatch(actions.addContentType())}>
                                        <PlusIcon color='#344054' />
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>))
                        }
                    </Box>

                    <Divider className='mv-24 border-1-gray' />

                    {/* Upload Asset */}
                    <Box className="flex-row-space-between gap-20">
                    <Box className="pb-12px text-align-center">
                                    {getValues('listImage_url') && (
                                        <img
                                            src={getValues('listImage_url')}
                                            width="100px"
                                            height="100px"
                                            className='br-50'
                                        />
                                    )}
                                </Box>
                        <Box className="flex-column-center border-1-gray-300 br-16px padding-tb-16-rl-24 wh-100" {...getRootProps()}>
                            <Box className="wh-40px bg-gray-100 br-50 border-6-gray-50">
                                <Upload />
                            </Box>
                            <Box className="flex-row gap-4">
                                <Typography className='text-sm-medium primary-600'>
                                    Click to upload
                                </Typography>
                                <Typography className='text-sm-regular gray-500'>
                                    or drag and drop
                                </Typography>
                            </Box>
                            <Box>
                                <Typography className='text-sm-regular gray-500'>
                                    PNG, JPG or JPEG
                                </Typography>
                            </Box>
                            <input
                                {...getInputProps()}
                                id="fileInput"
                            />

                            <input
                                type="file"
                                onChange={handleFileChange}
                                style={{ display: 'none' }}
                                id="fileInput"
                            />
                        </Box>
                    </Box>

                    <Divider className='mv-24 border-1-gray' />

                    {/* Editor */}
                    <Box className="box-sizing-border-box ">
                        <CustomEditor value={editCustomerData?.content} onChange={handleContentChange} />
                    </Box>

                    <Divider className='mv-24 border-1-gray' />

                    <Box className="flex-row-start-center gap-8">
                        <Checkbox
                            classes={{
                                root: classes.root,
                                checked: classes.checked,
                            }}
                            {...register('isChecked')}
                        />
                        <Typography className="text-sm-medium gray-700">I acknowledge that this campaign has met the required reviewer approvals</Typography>
                    </Box>
                </Box>

            </Grid>

            <Grid
                item
                xs={12}
                sx={{
                    flex: 1,
                    marginTop: 'auto',
                }}
            >
                <Divider className='border-1-gray' />
                    <Box className="flex-row-end-center gap-12 padding-tb-16-rl-24">
                        <CustomButton
                            title="Cancel"
                            handleClick={handleClose}
                        />
                        <CustomButton
                            title="Save"
                            titleColor="#FFFFFF"
                            buttonColor="#AD509E"
                            handleClick={handleSave}
                            type="submit"
                        />
                    </Box>
            </Grid>
        </Grid>
        <ConfirmationModal 
         open={open}
         onClose={onclose}
         content={<Box>
             <Typography className='mb-20px mt-20px' variant="body1">
             Please confirm this is a fully approved asset for distribution by your medical, legal and regulatory reviewers with an approved job code?
             </Typography>
         </Box>}
         title={""}
         primaryButtonText={"Yes"}
         onConfirm={finalSubmit}
          />
        </form>
    )
}

export default UploadAsset;